import { types as actions } from '../actions';

const defaultState = {
  list: [],
  currentSite: {},
  loading: true
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.GET_SITE_USER:
      return {
        ...state,
        siteId: action.siteId
      };
    case actions.SET_SITE_USER:
      return {
        ...state,
        userId: action.user.assetInfo.metadata.props.userId
      };
    case actions.SET_CURRENT_SITE:
      return {
        ...state,
        account: action.site.account,
        currentSite: action.site
      };
    case actions.ADDED_AREA:
      let site = state.list.find(site => site.id === action.area.site.id);
      if (site) {
        site.areaCount += 1;
      }
      return {
        ...state,
        list: [...state.list]
      };
    case actions.ADDED_SITE:
      return {
        ...state,
        list: [...state.list, action.site]
      };
    case actions.GET_SITES:
      return {
        ...state,
        loading: true
      };
    case actions.SET_SITES:
      return {
        ...state,
        list: action.sites,
        loading: false
      };
    case actions.REMOVE_SITE:
      const siteList = state.list.filter(site => {
        return site.id !== action.siteId;
      });
      return {
        ...state,
        list: siteList
      };
    case actions.EDITED_SITE: {
      const siteList = state.list.map(site => {
        if (site.id === action.site.id) {
          site = action.site;
        }
        return site;
      });
      return {
        ...state,
        list: siteList
      };
    }
    case actions.EDITED_SITE_LABELS: {
      const editedSite = action.site;
      const list = state.list.map(site => {
        if (site.id === editedSite.id) {
          site = editedSite;
        }
        return site;
      });
      return {
        ...state,
        currentSite: editedSite.id === state.currentSite.id ? editedSite : state.currentSite,
        list
      };
    }
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/sites/index.js